import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { FormattedMessage } from "react-intl";

import { ChatWithITSupportFlyoutLink } from "@/components/GetSupport";
import {
  Day1EventAction,
  Day1EventCategory,
  Day1EventLabel,
} from "@/types/snowplow-events";
/**
 * A component that renders a help text with a chat support link.
 * Uses FormattedMessage for internationalization and includes analytics tracking.
 *
 * @param {Function} onChatClick - Optional callback triggered when chat link is clicked
 */
interface MoreHelpProps {
  onChatClick?: () => void;
}

/**
 * Renders help text with an IT support chat link
 * @component MoreHelp
 * @param {object} props
 * @param {Function} props.onChatClick - Callback fired when chat link is clicked
 * @returns {Element} Text component with formatted message and chat link
 */
export const MoreHelp = ({ onChatClick }: MoreHelpProps) => {
  return (
    <Text fontSize="T100">
      <FormattedMessage
        id="faq-more-help"
        values={{
          chatWithITSupportLink: (
            <ChatWithITSupportFlyoutLink
              localeMessageId="text-chatWithITSupport"
              fontSize="T100"
              metricProps={{
                category: Day1EventCategory.PageLevel,
                action: Day1EventAction.ChatWithSupport,
                label: Day1EventLabel.MoreHelp,
              }}
              onClick={onChatClick}
            />
          ),
        }}
      />
    </Text>
  );
};
